'use client';

import { AdLayoutWatchdog } from 'components/util/AdLayoutWatchdog/AdLayoutWatchdog';
import { OptimizelyProvider } from 'providers/OptimizelyProvider';
import { useState } from 'react';
import { AdProvider } from '@/app_lib/providers/AdProvider';
import { useUser } from '@/app_lib/providers/UserProvider';
import type { PageAdConfig } from '@/app_lib/types/Ad';

export const AdOptimizelyProvider = ({ children }: { children: React.ReactNode }) => {
  const [pageAdConfig, setPageAdConfig] = useState<PageAdConfig | undefined>();
  const { userAccess } = useUser();
  const { loggedIn } = userAccess;

  return (
    <OptimizelyProvider pageAdConfig={pageAdConfig}>
      <AdLayoutWatchdog matchAdUnits={['/fortune/leaderboard_top']} />
      <AdProvider
        hasLoggedIn={loggedIn}
        pageAdConfig={pageAdConfig}
        setPageAdConfig={setPageAdConfig}
      >
        {children}
      </AdProvider>
    </OptimizelyProvider>
  );
};
